<template>
  <v-slide-y-transition mode="out-in">
    <div id="coa-forms" style="margin-top: -20px">
      <v-container grid-list-xl fluid>
        <v-layout row wrap>
          <v-flex lg12>
          <v-card pa-0>
            <v-toolbar card color="white">
              <v-text-field
              flat
              solo
              prepend-icon="search"
              placeholder="Type something"
              v-model="search"
              hide-details
              ></v-text-field>     
              <!--<v-btn icon>
                <v-icon>filter_list</v-icon>
              </v-btn>-->
              <router-link :to="{path: formPath}">
                  <v-btn color="success" fab small dark>
                    <v-icon>add</v-icon>
                  </v-btn>  
              </router-link>              
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                
                :headers="complex.headers"
                :search="search"
                :items="complex.items"
                :loading="loading"
                :pagination.sync="pagination"
                :rows-per-page-items="[10,25,50,{text:'All','value':-1}]"
                class="elevation-1"
                item-key="id"                            
                v-model="complex.selected"
                >
                <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>  
                <template slot="items" slot-scope="props">                         
                  <td>{{ props.item.id }}</td>
                  <td>{{ props.item.no }}</td>  
                  <td>{{ types[props.item.type] }}</td>  
                  <td>{{ props.item.question }}</td>  
                  <td>
                    <router-link :to="{path:formPath, query: {id: props.item.id}}">
                      <v-btn depressed icon class="primary--text" small>
                        <v-icon>edit</v-icon>
                      </v-btn>
                    </router-link>                          
                  </td>
                </template>
              </v-data-table>
            </v-card-text>            
          </v-card>
        </v-flex>                           
        </v-layout>
      </v-container>
    </div>
  </v-slide-y-transition>
</template>

<script>  
import Model       from '@/apps/admin/models/Quetionnaire';   
import Table2Excel from 'table2excel.js';  

var model = new Model();

export default {
    $_veeValidate: {
      validator: 'new'
    },    
    data: () => ({
        formPath : '/adm/quetionnaire/form',
        search   : '',
        loading  : true,
        pagination: {},
        complex  : {
            selected: [],
            headers: [
              { text: 'ID', value: 'id'  },
              { text: 'No', value: 'no'},
              { text: 'Type', value: 'type' },
              { text: 'Question', value : 'question'},
              { text: 'Action', value: '', align:'left' },              
            ],
            items: []
        },
        loadingDownload : false,
        types : {1:'Optional',2:'Additional',3:'Isian'},
        saksiBlank : [],
    }),  
    mounted(){ this.init() },        
    created () {
        if( model.vuex ){
            var context = this;        
            context.$store.watch(
                function (state) { return state },
                function () { model.all().then(data => { context.complex.items = data }) },{ deep: true }
            );                                     
        }
    },
    methods: {      
        format(tgl) { return this.$moment(tgl).format('DD-MM-YYYY')},
        
        init(){
            if(this.$route.query.flag){ 
                Object.assign(this.pagination, {sortBy : 'flag', descending:true});
            }            
            model.all().then(data => {      
                this.complex.items = data; 
                this.loading = false;
            });                                         
        },
             
        setSaksiProvinsiBlank(props){
          this.loadingDownload = true;
          model.saksiProvinsiBlank({provinsi_id:props.item.id}).then(res=>{
            this.saksiBlank = res.data;            
            setTimeout(()=>{
              new Table2Excel('.table2excel',{
                plugins: [{
                  worksheetCompleted ({ workbook, tables, worksheet, table }) {
                    worksheet.name = worksheet.getCell('C1').value;
                    //worksheet.getRow(1).hidden = true
                    //worksheet.getColumn(1).hidden = true
                  }
                }]
              }).export(props.item.nama); 
              this.loadingDownload = false;
            }, 500);            
          });          
        }
        
    }
}
</script>